var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 166,
    viewBox: "0 0 170 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.8498,
    cy: 18.5376,
    rx: 19.0959,
    ry: 18.5376,
    fill: "#FFECE8"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 150.44,
    cy: 60.2837,
    rx: 19.0959,
    ry: 18.5376,
    fill: "#FFECE8"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.592,
    cy: 29.1616,
    rx: 19.0959,
    ry: 18.5376,
    fill: "#FFECE8"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.0959,
    cy: 64.646,
    rx: 19.0959,
    ry: 18.5376,
    fill: "#FFECE8"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.1506,
    cy: 105.617,
    rx: 19.0959,
    ry: 18.5376,
    fill: "#FFECE8"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.6857,
    cy: 134.345,
    rx: 19.0959,
    ry: 18.5376,
    fill: "#FFECE8"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.256,
    cy: 134.345,
    rx: 19.0959,
    ry: 18.5376,
    fill: "#FFECE8"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 86.26,
    cy: 146.804,
    rx: 19.0959,
    ry: 18.5376,
    fill: "#FFECE8"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.932,
    cy: 100.285,
    rx: 19.0959,
    ry: 18.5376,
    fill: "#FFECE8"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.2678,
    cy: 32.602,
    rx: 19.0959,
    ry: 18.5376,
    fill: "#FFECE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeCircles);
export default __webpack_public_path__ + "static/media/OrangeCircles.0f6f6ac52ff6459c6bc0bf946de5b86a.svg";
export { ForwardRef as ReactComponent };